export default "__VITE_ASSET__BhiR0Yli__"